<template>
  <component :is="layout" v-bind="{ tenant: this.tenant }">
    <vue-progress-bar></vue-progress-bar>
    <router-view :layout.sync="layout" :tenant="this.tenant"/>
  </component>
</template>
<script>
import "./assets/app.css";
import axios from "axios";
import { fetchCountryListForPhoneNumber } from './api/calls.js';

export default {
  name: "ClientPortal",
  data() {
    return {
      tenant: {},
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "Default";
    },
  },
  mounted() {
    axios.get('/api/tenant').then((response) => {
      this.$nextTick(() => {
        this.tenant = response.data.data
      });
    })
    this.fetchUserCurrentLocation();
  },
  methods: {
    fetchUserCurrentLocation() {
      const storedLocation = localStorage.getItem('client_portal_user_location');
      const parsedLocation = JSON.parse(storedLocation);
      if (storedLocation && Object.keys(parsedLocation).length) {
        return { };
      }

      axios.get('https://guessgeolocation.introcept318.workers.dev')
        .then(( data ) => {
          const countryCode = data.data.country;
          fetchCountryListForPhoneNumber({ country_code: countryCode || '' })
            .then((data) => {
              if (data && data.data.data && data.data.data.length) {
                const userLocation = data.data.data[0];
                localStorage.setItem('client_portal_user_location', JSON.stringify(userLocation));
              }
            })
            .catch(() => {
              console.log("error fetching country for phone number");
            })
        }).catch(() => {
        console.log("error fetching user location");
      })
    }
  }
};
</script>
<style>
html {
  font-size: 14px;
}
.status:before {
  background-color: currentcolor;
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 7px;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
}

::-webkit-scrollbar:horizontal {
  height: 2px;
}
::-webkit-scrollbar-button {
  display: none;
  height: 2px;
  border-radius: 0px;
  background-color: #edf2f7;
}
::-webkit-scrollbar-button:hover {
  background-color: #aaa;
}
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: #757575;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #757575;
}
::-webkit-scrollbar-track {
  background-color: #dae1e7;
  border-left: 1px solid #b8c2cc;
}
::-webkit-scrollbar {
  width: 6px;
}
</style>
